import { actions } from './index';

export function fetchInvitationsSucceed(payload) {
  return {
    type: actions.GET_INVITATIONS_SUCCEED,
    payload
  };
}

export function destroyInvitationSucceed(payload) {
  return {
    type: actions.DESTROY_INVITATION_SUCCEED,
    payload
  };
}

export function reinviteSucceed(payload) {
  return {
    type: actions.REINVITE_USER_SUCCEED,
    payload
  };
}

export function invitationChangeAccountTypeSucceeded(payload) {
  return {
    type: actions.INVITATION_CHANGE_ACCOUNT_TYPE_SUCCEED,
    payload
  };
}
